"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverCenterVertical(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.leftUpAnchor.x + trigger.width / 2 - content.width / 2;
    var top = trigger.leftUpAnchor.y + trigger.height / 2 - content.height / 2;
    if (top < 0 || top + content.height > viewport.height) {
        return false;
    }
    if (left < 0) {
        return {
            left: 0,
            top: top,
        };
    }
    if (left + content.width > viewport.width && viewport.width - content.width >= 0) {
        return {
            left: viewport.width - content.width,
            top: top,
        };
    }
    return false;
}
exports.default = resolverCenterVertical;
//# sourceMappingURL=resolverCenterVertical.js.map